module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department01-ab3722b168313fb0834a3e0c1c73974f.jpg";